<template>
  <div class="d-block px-2 py-3">
    <section-filter @reset="resetFilter" @cari="searchTrx">
      <v-row>
        <v-col cols="6" class="py-0">
          <v-text-field
            v-model="invoiceNoFilter.value"
            outlined
            small
            dense
            hide-details
            class="searchInput"
            placeholder="Cari Kode Transaksi"
          >
            <div slot="append">
              <v-btn @click="searchTrx" small elevation="2" color="success">
                <v-icon center>mdi-magnify</v-icon>
              </v-btn>
            </div>
          </v-text-field>
        </v-col>
        <v-col cols="6" class="py-0">
          <v-text-field
            v-model="buyerNameFilter.value"
            outlined
            small
            dense
            hide-details
            class="searchInput"
            placeholder="Cari Buyer"
          >
            <div slot="append">
              <v-btn @click="searchTrx" small elevation="2" color="success">
                <v-icon center>mdi-magnify</v-icon>
              </v-btn>
            </div>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col cols="12" sm="5" class="py-0">
          <v-menu bottom offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateRangeText"
                prepend-inner-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                hide-details="auto"
                outlined
                clearable
                densed
                class="datePickerSmall"
                placeholder="Tanggal Riwayat Nego"
                @click:clear="clearDate"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date" range no-title></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="2" class="py-0">
          <v-btn @click="exportData">
            <v-icon>mdi-download</v-icon>
            Export Data
          </v-btn>
        </v-col>
      </v-row>
    </section-filter>

    <v-layout v-resize="onResize" column>
      <v-data-table
        v-model="selected"
        :server-items-length="historyNegoTransactionPagination.total_data"
        :items="listPesanan"
        :loading="loadingList"
        :headers="headers"
        :hide-default-header="true"
        :hide-default-footer="true"
        mobile-breakpoint="600"
        item-key="nego_id"
        class="elevation-1 border"
        :class="{ mobile: isMobile }"
        id="order-table"
      >
        <template v-slot:item.nego_id="{ item }">
          <v-row
            class="d-flex align-start pa-3"
            :class="isMobile ? 'flex-column' : 'flex-row'"
          >
            <v-col
              cols="12"
              sm="4"
              class="d-flex flex-column align-start justify-start"
              :class="{ 'mb-3 pa-0': isMobile }"
            >
              <router-link
                :to="'/seller/pesanan-saya'"
                class="font-weight-bold no-line"
                >{{ item.nego_trx_code }}</router-link
              >
              <v-chip
                small
                label
                class="mt-2 font-weight-bold"
                :class="colorStatus(item.nego_trx_detail_status_nego)"
                >{{ statusCaption(item.nego_trx_detail_status_nego) }}</v-chip
              >
            </v-col>
            <v-col
              cols="12"
              sm="2"
              class="text-subtitle-2 black-text font-weight-bold"
              :class="isMobile ? 'mb-3 mx-0 pa-0' : 'mx-5 px-0'"
            >
              {{ item.nego_trx_buyer_user_name }}
              <span class="d-block text-caption">{{
                item.nego_trx_buyer_user_mobilephone
              }}</span>
            </v-col>
            <v-col
              cols="12"
              sm="3"
              class="text-caption d-flex flex-column align-start"
              :class="{ 'mb-3 pa-0': isMobile }"
            >
              <div class="d-flex flex-column justify-start text-left">
                <strong>Tanggal Riwayat Nego</strong>
                <span class="pl-0">{{
                  formatDateText(item.nego_create_datetime, "DD MMM YYYY HH:mm")
                }}</span>
              </div>
            </v-col>
          </v-row>
          <hr />
          <v-row>
            <v-col
              cols="12"
              sm="6"
              class="text-left pr-0 d-flex flex-column flex-md-column justify-space-between"
            >
              <div class="d-flex flex-column align-start">
                <div class="text-subtitle-2 font-weight-bold black--text mb-1">
                  Nama Produk
                </div>
                <span class="text-subtitle-1">{{
                  item.nego_trx_detail_product_name
                }}</span>
              </div>
              <div class="d-flex flex-column align-start">
                <div class="text-subtitle-2 font-weight-bold black--text mb-1">
                  Harga Produk Ditawarkan
                </div>
                <span class="text-subtitle-1 font-weight-bold green--text">{{
                  item.nego_trx_detail_price_nego | toRupiah
                }}</span>
              </div>
            </v-col>
          </v-row>
        </template>

        <template v-slot:no-data>
          <div class="d-flex flex-column align-center py-5 px-5">
            <v-img
              width="150"
              height="150"
              max-width="150"
              class="py-5 my-4"
              src="/assets/seller/belum-ada-pesanan.svg"
            ></v-img>
            <div class="text-subtitle-1 black--text font-weight-bold">
              Tidak ada data transaksi yang dapat ditampilkan.
            </div>
          </div>
        </template>
      </v-data-table>
    </v-layout>

    <v-pagination
      v-if="
        historyNegoTransactionPagination.total_page > 1 &&
        listPesanan.length > 0
      "
      @input="updatePage"
      v-model="page"
      :length="historyNegoTransactionPagination.total_page"
      total-visible="7"
      circle
      class="d-flex justify-end no-button-focus py-2"
    ></v-pagination>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import moment from "moment";
import modalConfirm from "@/components/ModalDelete";
import sectionFilter from "../../../../../components/sectionFilter.vue";
export default {
  component: { moment },
  components: { modalConfirm, sectionFilter },
  props: ["allowedStatus", "payment"],
  data() {
    return {
      statusList: [
        { value: "pending", label: "Pending" },
        { value: "approved", label: "Approved" },
        { value: "rejected", label: "Rejected" },
      ],
      lacakStatusPesanan: false,
      allowChangeResi: false,
      loadingDetail: false,
      loadingStatus: false,
      loadingList: false,
      loadingTransaksi: false,
      dialogStatusPesanan: false,
      dialogSellerNotes: false,
      dialogNego: false,
      formNego: [],
      dialogLacak: false,
      dialogCancelOrder: false,
      dialogConfirmTerimaorder: false,
      dialogConfirmKirim: false,
      dialogConfirmRequestPickup: false,
      listPesanan: [],
      pickDate: false,
      pickup_date: "",
      courier_resi: "",
      courier_note: "",
      noresiRules: [(v) => !!v || "Nomor resi tidak boleh kosong"],
      noPickupdate: [(v) => !!v || "Tanggal pengambilan tidak boleh kosong"],
      panel: [0],
      menuDate: false,
      filterOptions: [
        {
          label: "No. Invoice",
          value: "invoice",
        },
        {
          label: "Nama Pembeli",
          value: "buyer",
        },
      ],
      filter: {
        type: {
          label: "No. Invoice",
          value: "invoice",
        },
        search: "",
        filterId: null,
        sortId: null,
        dateRange: null,
      },
      selected: [],
      selectedItem: {
        trx_id: "",
        is_drop: 0,
      },
      expanded: [],
      headers: [
        {
          text: "Info Pesanan",
          align: "start",
          sortable: false,
          value: "nego_id",
        },
        // { text: "action", value: "data-table-expand" },
      ],
      pembatalanOpt: [
        {
          id: 0,
          label: "Stok Tidak Tersedia",
        },
        {
          id: 1,
          label: "Ekspedisi Tutup",
        },
        {
          id: 2,
          label: "Toko Sudah Tidak Aktif",
        },
        {
          id: 3,
          label: "Stok di Gudang Rusak",
        },
      ],
      page: 1,
      limit: 5,
      sort: {},
      sortBy: "nego_create_datetime",
      sortDir: "desc",
      listSort: [
        {
          sortBy: "product_price",
          sortDir: "ASC",
          sortLabel: "Harga Terendah",
        },
        {
          sortBy: "product_price",
          sortDir: "DESC",
          sortLabel: "Harga Tertinggi",
        },
        {
          sortBy: "product_input_datetime",
          sortDir: "DESC",
          sortLabel: "Produk Terbaru",
        },
        {
          sortBy: "product_sold_count",
          sortDir: "DESC",
          sortLabel: "Produk Terlaris",
        },
        {
          sortBy: "product_view_count",
          sortDir: "DESC",
          sortLabel: "Produk Terpopuler",
        },
      ],
      date: [],
      buyerNameFilter: {
        value: "",
        comparison: "like",
        type: "string",
        field: "nego_trx_buyer_user_name",
      },
      invoiceNoFilter: {
        value: "",
        comparison: "like",
        type: "string",
        field: "nego_trx_code",
      },
      tglTransaksiFilter: {
        value: "",
        comparison: "like",
        type: "string",
        field: "payment_detail.create_datetime",
      },
      statusFilter: {
        value: "",
        comparison: "=",
        type: "list",
        field: "nego_trx_detail_status_nego",
      },
      paymentFilter: {
        value: "payment_store",
        comparison: "=",
        type: "string",
        field: "trx_payment_method",
      },
      dateTrxRange: {
        value: "",
        comparison: "bet",
        type: "date",
        field: "nego_create_datetime",
      },
      historyStatus: null,
      isMobile: false,
      params: [],
    };
  },

  computed: {
    ...mapState("options", ["bankAccountList"]),
    dateRangeText() {
      return this.date.join(" ~ ");
    },
    ...mapState("transaksiSeller", [
      "historyTrackingData",
      "historyNegoTransactionData",
      "historyNegoTransactionPagination",
      "detailPesanan",
      "response",
      "responseError",
    ]),
    // dateRangeText: {
    //   get() {
    //     let dates = this.filter.dateRange
    //       ? new Date(this.filter.dateRange)
    //       : null;
    //     return dates ? moment(dates).format("DD MMM YYYY") : null;
    //   },
    //   set() {
    //     let dates = this.filter.dateRange
    //       ? new Date(this.filter.dateRange)
    //       : null;
    //     return dates ? moment(dates).format("DD MMM YYYY") : null;
    //   },
    // },
  },

  async mounted() {
    this.getBankAccountList();
    if (this.$route.query.code) {
      this.invoiceNoFilter.value = this.$route.query.code;
    }
    // await this.getListPesanan();
    this.searchTrx();
  },

  methods: {
    exportData(){
      this.$store.dispatch('transaksiSeller/excelHistoryNegoTransaction', this.queryString({
          limit: this.limit,
          page: this.page,
          params: this.params,
          sort: this.sortBy,
          dir: this.sortDir,
        })).then(res => {
          window.open(res.url, "_blank");
        })
    },
    resetFilter() {
      if (this.$route.query.code) {
        this.$router.replace({ query: {} });
      }
      this.invoiceNoFilter.value = "";
      this.buyerNameFilter.value = "";
      // this.tglTransaksiFilter.value = "";
      // this.statusFilter.value = "";

      this.searchTrx();
    },
    confirmValidation(formData) {
      this.uploadFinanceSubmit(formData).then(() => {
        this.$refs.modalPayment.modalHide();
        this.searchTrx();
      });
    },
    uploadPayment(data) {
      let bank = this.bankAccountList.find((el) => {
        return (
          el.bank_account_bank_name == data.cs_bank_name &&
          el.bank_account_id == data.cs_bank_id
        );
      });
      this.$refs.modalPayment.modalShow(
        bank,
        {
          payment_detail_id: data.id,
          cs_bank_id: data.cs_bank_id,
          total_invoice: Number(data.total_remaining_debt),
          finance_amount: 0,
          note: data.cs_note,
          payment_status: 0,
          cs_attachment_url: data.cs_attachment_url,
          previous_status: data.status,
        },
        true
      );
    },
    previewPayment(data) {
      let bank = this.bankAccountList.find((el) => {
        return (
          el.bank_account_bank_name == data.cs_bank_name &&
          el.bank_account_id == data.cs_bank_id
        );
      });
      this.$refs.modalPayment.modalShow(
        bank,
        {
          payment_detail_id: data.id,
          cs_bank_id: data.cs_bank_id,
          total_invoice: Number(data.finance_total_remaining_debt_before),
          finance_amount: Number(data.total_paid),
          note: data.cs_note,
          payment_status: data.status,
          cs_attachment_url: data.cs_attachment_url,
          previous_status: data.status,
        },
        false
      );
    },
    previewHargaNego([item]) {
      this.dialogNego = true;
      // {
      // "trx_detail_id": "49",
      // "trx_detail_product_id": "2",
      // "trx_detail_product_name": "AMOX-AB - Amoxsan 500 Mg Kapsul",
      // // "trx_detail_price": 16850,
      // // "trx_detail_price_nego": "15000",
      // // "trx_detail_status_nego": "submitted",
      // // "trx_detail_nego_is_member": "1",
      // // "trx_detail_nego_is_seller": "0"
      // // }

      // // product_name,
      // min_price_nego,
      // cart_detail_id,
      // cart_detail_product_id,
      // cart_detail_price,
      // cart_detail_price_nego:cart_detail_price_nego,
      this.formNego = item.trx_data_nego.trx_nego_items.map((i) => {
        const {
          trx_detail_product_name: product_name,
          trx_detail_id: cart_detail_id,
          trx_detail_product_id: cart_detail_product_id,
          trx_detail_price: cart_detail_price,
          trx_detail_price_nego: cart_detail_price_nego,
        } = i;
        return {
          product_name,
          cart_detail_id,
          cart_detail_product_id,
          cart_detail_price,
          cart_detail_price_nego,
        };
      });
      console.log([item]);
    },
    ...mapActions("transaksiSeller", [
      "getHistoryTracking",
      "getTracking",
      "getTrackingKiriminaja",
      "historyNegoTransaction",
      "getPesananDetail",
      "prosesPesanan",
      "kirimPesanan",
      "pickupStore",
      "getStatusPesanan",
      "uploadFinanceSubmit",
      "paymentStorePaid",
      "paymentStoreCancel",
      "changeResi",
      "cancelPesanan",
      "requestPickupPesanan",
    ]),
    ...mapActions("options", ["getBankList", "getBankAccountList"]),
    ...mapMutations(["makeAlert"]),
    getDetailHistoryTracking(trxCode) {
      let params = [];
      params = { trx_code: trxCode };
      this.getHistoryTracking(params)
        .then(async () => {
          this.loadingList = false;
        })
        .catch(() => {
          this.loadingList = true;
        });
    },
    async getDetailTracking(trxCode, agregator, oidKiriminaja) {
      let params = [];
      params = { trx_code: trxCode, order_id: oidKiriminaja };
      if (agregator == "kiriminaja") {
        await this.getTrackingKiriminaja(params)
          .then(async () => {
            this.loadingList = false;
          })
          .catch(() => {
            this.loadingList = true;
          });
      } else {
        await this.getTracking(params)
          .then(async () => {
            this.loadingList = false;
          })
          .catch(() => {
            this.loadingList = true;
          });
      }
    },
    async clearDate() {
      this.date = await [];
      this.dateTrxRange.value = "";
      this.searchTrx();
    },
    async getListPesanan() {
      this.loadingList = await true;
      let params = await [];
      let status = "";
      console.log(this.allowedStatus);
      for (let i = 0; i < this.allowedStatus.length; i++) {
        status +=
          i < this.allowedStatus.length - 1
            ? this.allowedStatus[i] + "::"
            : this.allowedStatus[i];
      }
      this.statusFilter.value = await status;
      if (this.statusFilter.value) params.push(this.statusFilter);

      if (this.payment == "store") params.push(this.paymentFilter);

      this.page = await 1;
      await this.historyNegoTransaction(
        this.queryString({
          limit: this.limit,
          page: this.page,
          params: params,
          sort: this.sortBy,
          dir: this.sortDir,
        })
      )
        .then(async () => {
          this.listPesanan = await this.historyNegoTransactionData;
          this.loadingList = false;
        })
        .catch(() => {
          this.loadingList = true;
        });
    },

    filterAllowedStatus(data) {
      let showList = data.filter((d) =>
        this.allowedStatus.includes(d.trx_status)
      );
      return showList;
    },

    statusCaption(status) {
      let listStatus = {
        pending: "Menunggu Verifikasi",
        approved: "Pengajuan Disetujui",
        rejected: "Pengajuan Ditolak",
        submitted: "Harga Nego Diajukan",
      };
      if (listStatus[status]) return listStatus[status];
    },

    colorStatus(status) {
      let listStatus = {
        pending: "orange darken-1 white--text",
        approved: "green white--text",
        rejected: "red white--text",
      };
      if (listStatus[status]) return listStatus[status];
    },

    async openReminderDialog(item) {
      this.selectedItem = await item;
      this.dialogReminderStock = true;
    },

    formatDateText(params, format) {
      let dates = params ? new Date(params) : null;
      return dates ? moment(dates).format(format) : null;
    },

    async loadDetailPesanan({ item }) {
      this.loadingDetail = await true;
      const params = await {
        id: item.trx_id,
      };
      await this.getPesananDetail(params).then(() => {
        this.allowChangeResi = false;
        this.courier_note = this.detailPesanan.trx_courier_note;
        this.courier_resi = this.detailPesanan.trx_courier_resi;
        this.pickup_date = this.detailPesanan.trx_pick_up_date;

        const histories = [
          {
            trx_status: "created",
            trx_status_datetime: this.detailPesanan.trx_status_created_datetime,
            trx_status_desc:
              "Pembeli membuat pemesanan baru dari Toko Anda. Menunggu pembayaran dari pembeli.",
          },
          {
            trx_status: "paid",
            trx_status_datetime: this.detailPesanan.trx_status_paid_datetime,
            trx_status_desc:
              "Pembayaran oleh pembeli Berhasil. Pemesanan Barang akan diteruskan ke Penjual.",
          },
          {
            trx_status: "processed",
            trx_status_datetime:
              this.detailPesanan.trx_status_processed_datetime,
            trx_status_desc:
              "Pesanan sudah diterima Penjual dan diproses ke Pengiriman.",
          },
          {
            trx_status: "pickup",
            trx_status_datetime: this.detailPesanan.trx_status_pickup_datetime,
            trx_status_desc: "Permintaan pickup/drop off sudah dilakukan.",
          },
          {
            trx_status: "on_delivery",
            trx_status_datetime:
              this.detailPesanan.trx_status_on_delivery_datetime,
            trx_status_desc:
              "Pesanan telah dikirimkan dengan nomor resi " +
              this.courier_resi +
              " .",
          },
          {
            trx_status: "completed",
            trx_status_datetime:
              this.detailPesanan.trx_status_completed_datetime,
            trx_status_desc:
              "Pemesanan telah selesai dan diterima oleh Pembeli.",
          },
          {
            trx_status: "cancel",
            trx_status_datetime: this.detailPesanan.trx_status_cancel_datetime,
            trx_status_desc: "Pemesanan Anda telah dibatalkan.",
          },
          {
            trx_status: "rejected_admin",
            trx_status_datetime:
              this.detailPesanan.trx_status_rejected_admin_datetime,
            trx_status_desc: "Pemesanan Anda tidak disetujui oleh Admin.",
          },
        ];
        const sortedActivities = histories.sort((a, b) => {
          if (a.trx_status_datetime > b.trx_status_datetime) return -1;
          if (a.trx_status_datetime < b.trx_status_datetime) return 1;
          return 0;
        });
        this.historyStatus = sortedActivities;
      });
      this.loadingDetail = false;
    },

    setSlugProduct(id, nama) {
      return id + "-" + nama.toLowerCase().replace(/ /g, "-");
    },

    async searchTrx() {
      this.loadingList = await true;
      // let params = await [];
      this.params = await [];
      if (this.invoiceNoFilter.value)
        await this.params.push(this.invoiceNoFilter);
      if (this.buyerNameFilter.value)
        await this.params.push(this.buyerNameFilter);
      if (this.tglTransaksiFilter.value)
        await this.params.push(this.tglTransaksiFilter);
      if (this.allowedStatus.length === 1)
        this.statusFilter.value = await this.allowedStatus;
      if (this.statusFilter.value) await this.params.push(this.statusFilter);
      if (this.date.length == 1) {
        this.dateTrxRange.value = this.createFilterDate(
          this.date[0],
          this.date[0]
        );
      } else if (this.date.length == 2) {
        this.dateTrxRange.value = this.createFilterDate(
          this.date[0],
          this.date[1]
        );
      }
      if (this.dateTrxRange.value !== "") {
        this.params.push(this.dateTrxRange);
      }
      this.page = await 1;
      await this.historyNegoTransaction(
        this.queryString({
          limit: this.limit,
          page: this.page,
          params: this.params,
          sort: this.sortBy,
          dir: this.sortDir,
        })
      )
        .then(async () => {
          this.listPesanan = await this.historyNegoTransactionData;
          this.loadingList = false;
        })
        .catch(() => {
          this.loadingList = false;
        });
    },
    createFilterDate(date1, date2) {
      return (
        moment(date1).format("YYYY-MM-DD") +
        "::" +
        moment(date2).format("YYYY-MM-DD")
      );
    },
    async clearSearch() {
      this.filter.search = await "";
      this.filter.type = await {
        label: "No. Invoice",
        value: "invoice",
      };
      this.buyerNameFilter.value = await "";
      this.invoiceNoFilter.value = await "";
      this.searchTrx();
    },

    async updatePage(val) {
      // this.loadingList = await true;
      // let params = await [];
      // let status = "";

      // for (let i = 0; i < this.allowedStatus.length; i++) {
      //   status +=
      //     i < this.allowedStatus.length - 1
      //       ? this.allowedStatus[i] + "::"
      //       : this.allowedStatus[i];
      // }
      // this.statusFilter.value = await status;
      // if (this.statusFilter.value) params.push(this.statusFilter);
      this.page = await val;
      await this.historyNegoTransaction(
        this.queryString({
          limit: this.limit,
          page: this.page,
          params: this.params,
          sort: this.sortBy,
          dir: this.sortDir,
        })
      )
        .then(async () => {
          this.listPesanan = await this.historyNegoTransactionData;
          this.loadingList = false;
        })
        .catch(() => {
          this.loadingList = false;
        });
      // await this.historyNegoTransaction(
      //   this.queryString({ limit: 5, page: val, params: params })
      // )
      //   .then(async () => {
      //     this.listPesanan = await this.historyNegoTransactionData;
      //     this.loadingList = false;
      //   })
      //   .catch(() => {
      //     this.loadingList = false;
      //   });
    },

    async openConfirmProses(item) {
      this.selectedItem = await item;
      this.dialogConfirmTerimaorder = true;
      // this.clearSearch();
      this.getListPesanan();
    },

    async openConfirmKirim(item) {
      if (this.$refs.formKirimPesanan.validate()) {
        this.selectedItem = await item;
        this.dialogConfirmKirim = true;
        this.getListPesanan();
      }
    },

    async openConfirmRequestPickup(item, is_drop = 0) {
      if (this.$refs.formKirimPesanan.validate()) {
        this.selectedItem = await item;
        this.selectedItem.is_drop = await is_drop;
        this.dialogConfirmRequestPickup = true;
        this.getListPesanan();
      }
    },

    async openConfirmChangeResi(item) {
      if (this.$refs.formChangeResi.validate()) {
        this.selectedItem = await item;
        this.dialogConfirmTerimaorder = true;
        this.getListPesanan();
      }
    },

    async prosesPesananAct(id) {
      this.loadingStatus = await true;
      const params = await {
        trx_id: id,
      };
      // alert("tes");
      // return;
      await this.prosesPesanan(params)
        .then(async () => {
          await this.makeAlert({
            code: "success",
            type: "success",
            message: this.response.message,
            show: true,
          });

          this.selectedItem = await null;
          this.dialogConfirmTerimaorder = await false;
          this.loadingStatus = await false;
          await this.getListPesanan();
          await this.getStatusPesanan();
          await location.reload();
        })
        .catch(() => {
          this.selectedItem = null;
          this.dialogConfirmTerimaorder = false;
          this.loadingStatus = false;
          this.getListPesanan();
          this.getStatusPesanan();
        });
    },

    async ubahResi(id) {
      this.loadingStatus = await true;
      const params = await {
        trx_id: id,
        trx_courier_resi: this.courier_resi,
      };

      await this.changeResi(params)
        .then(async () => {
          await this.makeAlert({
            code: "success",
            type: "success",
            message: this.response.message,
            show: true,
          });
          await this.getListPesanan();
          await this.getStatusPesanan();
          await this.loadDetailPesanan({
            item: params,
          });
          this.selectedItem = await null;
          this.dialogConfirmTerimaorder = await false;
          this.loadingStatus = false;
          this.allowChangeResi = false;
        })
        .catch(() => {
          this.selectedItem = null;
          this.dialogConfirmTerimaorder = false;
          this.loadingStatus = false;
        });
    },

    async requestPickupPesananAct(id, is_drop = 0) {
      this.loadingStatus = await true;
      const params = await {
        trx_id: id,
        trx_courier_note: this.courier_note,
        is_drop: is_drop,
      };

      await this.requestPickupPesanan(params)
        .then(async () => {
          await this.makeAlert({
            code: "success",
            type: "success",
            message: this.response.message,
            show: true,
          });
          await this.loadDetailPesanan({
            item: params,
          });
          await this.getListPesanan();
          await this.getStatusPesanan();
          this.selectedItem = await null;
          this.dialogConfirmRequestPickup = await false;
          this.loadingStatus = false;
        })
        .catch(() => {
          this.selectedItem = null;
          this.dialogConfirmRequestPickup = false;
          this.loadingStatus = false;
        });
    },

    async kirimPesananAct(id) {
      this.loadingStatus = await true;
      const params = await {
        trx_id: id,
        trx_courier_resi: this.courier_resi,
        trx_courier_note: this.courier_note,
      };

      await this.kirimPesanan(params)
        .then(async () => {
          await this.makeAlert({
            code: "success",
            type: "success",
            message: this.response.message,
            show: true,
          });
          await this.loadDetailPesanan({
            item: params,
          });
          await this.getListPesanan();
          await this.getStatusPesanan();
          this.selectedItem = await null;
          this.dialogConfirmKirim = await false;
          this.loadingStatus = false;
        })
        .catch(() => {
          this.selectedItem = null;
          this.dialogConfirmKirim = false;
          this.loadingStatus = false;
        });
    },

    async pengambilanPesananAct(id, date) {
      this.loadingStatus = await true;
      const params = await {
        trx_id: id,
        pick_up_date: date,
        trx_courier_note: this.courier_note,
      };

      await this.pickupStore(params)
        .then(async () => {
          await this.makeAlert({
            code: "success",
            type: "success",
            message: this.response.message,
            show: true,
          });
          await this.loadDetailPesanan({
            item: params,
          });
          await this.getListPesanan();
          await this.getStatusPesanan();
          this.selectedItem = await null;
          this.dialogConfirmKirim = await false;
          this.loadingStatus = false;
        })
        .catch(() => {
          this.selectedItem = null;
          this.dialogConfirmKirim = false;
          this.loadingStatus = false;
        });
    },

    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },

    printInvoice(id) {
      let routeData = this.$router.resolve({ path: "/seller/invoice/" + id });
      window.open(routeData.href, "_blank");
    },
    printShipping(id) {
      let routeData = this.$router.resolve({
        path: "/seller/shipping-label/" + id,
      });
      window.open(routeData.href, "_blank");
    },
    confirmPayment(data) {
      this.paymentStorePaid({
        trx_id: data.trx_id,
      })
        .then(async () => {
          await this.makeAlert({
            code: "success",
            type: "success",
            message: this.response.message,
            show: true,
          });
          await this.getListPesanan();
          await this.getStatusPesanan();
          this.loadingStatus = false;
        })
        .catch(() => {
          this.loadingStatus = false;
        });
    },
    cancelTransaction(data) {
      this.paymentStoreCancel({
        trx_id: data.trx_id,
      })
        .then(async () => {
          await this.makeAlert({
            code: "success",
            type: "success",
            message: this.response.message,
            show: true,
          });
          await this.getListPesanan();
          await this.getStatusPesanan();
          this.loadingStatus = false;
        })
        .catch(() => {
          this.loadingStatus = false;
        });
    },
    cancelTransactionV2(data) {
      this.cancelPesanan({
        trx_id: data.trx_id,
      })
        .then(async () => {
          await this.makeAlert({
            code: "success",
            type: "success",
            message: this.response.message,
            show: true,
          });
          await this.getListPesanan();
          await this.getStatusPesanan();
          this.loadingStatus = false;
        })
        .catch(() => {
          this.loadingStatus = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.v-spacer {
  width: 1px;
  height: 30px;
  background: transparent;
  display: block;
  position: relative;
  margin: 0 auto;
  border-left: 3px dotted #ccc;
}
</style>
